import { Grid } from "antd";
export const { useBreakpoint } = Grid;
